import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
// config
import colors from "../../../config/colors";
// redux
import { useDispatch } from "../../../redux/store";
import { setWishlistCreatorId } from "../../../redux/slices/creator";
// ga
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
  LABEL,
  LABEL2,
} from "../../../utils/gaUtils";

const Actions = ({ item }) => {
  const dispatch = useDispatch();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const timeoutRef = useRef(null);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleAddToWishlist = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.ADD_TO_WISHLIST,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.DISCOVER_CARD,
    });
    dispatch(setWishlistCreatorId(item?.wishlink_username));
  };

  const handleTooltipClick = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.CONTACT_CLICK,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.DISCOVER_CARD,
    });
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!tooltipOpen) {
      // Show tooltip and set timer to hide it after 4 seconds
      setTooltipOpen(true);
      timeoutRef.current = setTimeout(() => {
        setTooltipOpen(false);
        timeoutRef.current = null;
      }, 2000);
    } else {
      // If already open, close it immediately
      setTooltipOpen(false);
      timeoutRef.current = null;
    }
  };

  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
      <Box
        sx={{
          cursor: "pointer",
          borderRadius: "4px",
          border: `1px solid ${colors.gray100}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: "6px",
          flex: 1,
          gap: "7px",
        }}
        onClick={handleAddToWishlist}
      >
        <AddIcon
          sx={{
            fontSize: 18,
            color: colors.primary500,
            opacity: 0.7,
            fontWeight: 900,
            lineHeight: "20px",
          }}
        />
        <Typography
          fontSize={12}
          fontWeight={500}
          lineHeight="18px"
          color={colors.gray200}
        >
          Add
        </Typography>
      </Box>
      <Tooltip
        title="Chat coming soon!"
        arrow
        open={tooltipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <Box
          sx={{
            cursor: "pointer",
            borderRadius: "4px",
            border: `1px solid ${colors.gray100}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: "6px",
            flex: 1,
            gap: "7px",
          }}
          onClick={handleTooltipClick}
        >
          <EmailOutlinedIcon
            sx={{
              fontSize: 18,
              color: colors.primary500,
              opacity: 0.7,
              fontWeight: 900,
              lineHeight: "20px",
            }}
          />
          <Typography
            fontSize={12}
            fontWeight={500}
            lineHeight="18px"
            color={colors.gray200}
          >
            Contact
          </Typography>
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default Actions;
